/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import axios from "axios";
//import { useHistory, useParams } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
 
const EditMovie = () => {
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    //const history = useHistory();
    const history = useNavigate();
    const { id } = useParams();
 
    const updateMovie = async (e) => {
        e.preventDefault();
        await axios.patch(`http://localhost:5000/movies/${id}`,{
            title: title,
            price: price
        });
        //history.push("/");
        history("/");
    }
 
    useEffect(() => {
        getMovieById();
    }, []);
 
    const getMovieById = async () => {
        const response = await axios.get(`http://localhost:5000/movies/${id}`);
        setTitle(response.data.title);
        setPrice(response.data.price);
    }
 
    return (
        <div>
            <form onSubmit={ updateMovie }>
                <div className="field">
                    <label className="label">Title</label>
                    <input 
                        className="input"
                        type="text"
                        placeholder="Title"
                        value={ title }
                        onChange={ (e) => setTitle(e.target.value) }
                    />
                </div>
 
                <div className="field">
                    <label className="label">Price</label>
                    <input 
                        className="input"
                        type="text"
                        placeholder="Price"
                        value={ price }
                        onChange={ (e) => setPrice(e.target.value) }
                    />
                </div>
 
                <div className="field">
                    <button className="button is-primary">Update</button>
                </div>
            </form>
        </div>
    )
}
 
export default EditMovie